// @@search logic
require('./_fix-re-wks')('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/~/core-js/modules/es6.regexp.search.js
// module id = ../../../../core-js/modules/es6.regexp.search.js
// module chunks = 0